// extracted by mini-css-extract-plugin
export default {"component":"CarPrizeDraw-module__component-Rzp_","heroSection":"CarPrizeDraw-module__heroSection-dZ3d"};